var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mounted
    ? _c(
        "div",
        { staticClass: "application-career profile-view" },
        [
          _c("JonInfo", {
            scopedSlots: _vm._u(
              [
                {
                  key: "message",
                  fn: function() {
                    return [
                      _vm._v(
                        "\n\t\t\tDurch die Eingabe deines anonymen Lebenslaufs, kannst du deine Chancen erhöhen!"
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("b", [
                        _vm._v(
                          "Gib zumindest die letzten 6 Jahre deines Lebens ein - Beruf, Ausbildung,\n\t\t\t\tsonstige Lebensstationen."
                        )
                      ])
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2874812671
            )
          }),
          _vm._v(" "),
          _vm.showGaps
            ? _c(
                "div",
                { staticClass: "alert-simple alert-simple-error mt-3" },
                [
                  _c("div", [
                    _vm._v(
                      "Bitte gib zumindest die letzten 6 Jahre ein, um gefunden zu werden!"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      "Folgende Zeiträume fehlen: " + _vm._s(_vm.gapsAsList)
                    )
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("Group", {
            attrs: {
              title: "Berufserfahrung & Weitere/Sonstige Lebensstationen",
              meta: _vm.meta,
              "has-any-career-item": _vm.careers.length > 0,
              items: _vm.getItemsByGroupType("job-and-simple")
            },
            on: {
              removeItem: function($event) {
                _vm.careerToRemove = $event
              },
              saveItem: _vm.save
            }
          }),
          _vm._v(" "),
          _c("Group", {
            attrs: {
              title: "Ausbildung",
              meta: _vm.meta,
              items: _vm.getItemsByGroupType("education"),
              education: "",
              section: {
                id: _vm.sectionEducation,
                finished: _vm.isEducationFinished
              },
              "further-title-items":
                "Hast du eine weitere Ausbildung / Zusatzausbildung?",
              "further-title-no-items":
                "Hast du eine Ausbildung / Zusatzausbildung?"
            },
            on: {
              removeItem: function($event) {
                _vm.careerToRemove = $event
              },
              saveItem: _vm.save,
              finished: _vm.educationFinished
            }
          }),
          _vm._v(" "),
          _vm.careerToRemove
            ? _c(
                "ConfirmPopUp",
                {
                  attrs: { title: "Erfahrung löschen" },
                  on: {
                    confirm: function($event) {
                      return _vm.remove(_vm.careerToRemove)
                    },
                    hidden: function($event) {
                      _vm.careerToRemove = undefined
                    }
                  }
                },
                [
                  _vm._v("\n\t\tMöchtest du die Erfahrung "),
                  _c("b", [_vm._v(_vm._s(_vm.careerToRemove.title))]),
                  _vm._v(" wirklich löschen?\n\t")
                ]
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }